export const refsBestsellers = {
  bestsellersList: document.querySelector('.bestsellers-list'),
  loaderBestsellers: document.querySelector('.bestsellers-loader'),
  buttonWrapper: document.querySelector('.bestsellers-nav-btn'),
};
